import React from "react";

export const Figma = (props) => {

  const data = props.data || {};

  return data?.url ? (
    <section>
      <div className="container">
        <div className="row">
          <div className="col-12 col-xl-10 offset-xl-1">
            {data.url && (
              <div className="ratio ratio-16x9 border rounded-32 overflow-hidden">
                <iframe loading="lazy" src={`${data.url}#toolbar=0`} title="Events"></iframe>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  ) : '';
}
